import "./App.css";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

import { authProvider } from "./authProvider";
import { Loader } from "./Loader";
// import { useLocation } from "react-router-dom";

function App() {
  const [loading, setLoading] = useState(false);
  const [filePath, setFilePath] = useState(null);
  // const [leadId, setLeadId] = useState("");
  // const location = useLocation();

  // useEffect(() => {
  //   setLoading(true);
  //   let query = new URLSearchParams(location.search);
  //   if (query) {
  //     let leadId = query.get("leadId");
  //     if (leadId) {
  //       setLeadId(leadId);
  //     }
  //   }
  // }, [location]);

  useEffect(() => {
    setLoading(true);
    const leadIdParam = sessionStorage.getItem("leadId")
    if (leadIdParam) {
      // setLeadId(leadIdParam);
      getFileData(leadIdParam);
    }
  }, []);

  const base64ToBlob = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });

    return blob;
  };

  const httpRequest = async (url, method, body, authToken) => {
    const accountInfo = authProvider.getAccountInfo();
    let headers = {
      "Content-Type": "application/json",
      Authorization: authToken
        ? "Bearer " + authToken
        : "Bearer " + accountInfo.jwtIdToken,
      "x-alorica-agentid": accountInfo.account.userName,
    };
    return await fetch(url, {
      method: method,
      headers: headers,
      body: body ? JSON.stringify(body) : undefined,
    })
      .then(onSubmitSuccess)
      .catch(onSubmitError);
  };

  const onSubmitSuccess = (res) => {
    if (res.status === 200 || res.status === 204) {
      return res.json();
    } else {
      if (res.status == 401) {
        showErrorPopup(
          "Unauthorized Access. Please reach out to the administrator.",
        ).then((x) => {
          getFileData();
        });
      } else {
        res.json().then((x) => {
          let err = "";
          if (x.ExceptionMessage) {
            err = x.ExceptionMessage;
          } else if (res.status === 400) {
            err = x.map((y) => y.message).join(",");
          } else {
            err = x.map((item) => item.Message).join(",");
          }
          showErrorPopup(err).then((x) => {
            getFileData();
          });
        });
      }
    }
  };

  const onSubmitError = (ex) => {
    showErrorPopup(ex.message).then((x) => {
      getFileData();
    });
  };

  const showErrorPopup = (message) => {
    return Swal.fire({
      title: "Error Occured",
      text: message,
      icon: "error",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonColor: "#FF00000",
      showConfirmButton: false,
      cancelButtonText: "Try Again",
    });
  };

  const getFileData = (leadId) => {
    // const leadId = "5D20F361-E811-4F72-BE6F-E525B0DFD5FC";// sessionStorage.getItem("leadId")
    const data = {
      leadId: leadId,
    };
    const url = process.env.REACT_APP_API_URL + "register-agent";

    httpRequest(url, "POST", data).then((resp) => {
      if (resp && resp.hcToken) {
        getLeads(resp.hcToken);
      }
    });
  };

  const getLeads = (hcToken) => {
    setLoading(true);

    const url = process.env.REACT_APP_API_URL + "leads";

    httpRequest(url, "GET", null, hcToken).then((resp) => {
      setLoading(false);
      if (resp && resp.data) {
        const base64Response = resp.data;
        const pdfBlob = base64ToBlob(base64Response);
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setFilePath(pdfUrl);
      }
    });
  };

  return (
    <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
      {loading ? <Loader /> : <></>}
      {filePath ? (
        <iframe
          style={{ height: "calc(100vh)", width: "100%" }}
          allowFullScreen
          frameBorder="0"
          src={filePath + "#view=FitH&toolbar=0"}
        ></iframe>
      ) : (
        <></>
      )}
    </div>
  );
}

export default App;
